const LastUpdate = () => {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);

  const formattedDate = firstDay.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });

  return <div>Last update: {formattedDate}.</div>;
};

export default LastUpdate;
